/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {ChangeDetectorRef, Component, Inject, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {deferMarkForCheck} from '../../common/util/defer-mark-for-check';

import template from './order-list-widget.component.html';
import {OrderResource} from '../../../components/api/resources/resource/order.resource';
import {
  WorkspaceListColumn,
  isWorkspaceColumnSortable,
  workspaceChangePage,
  workspaceColumnLabel,
  workspacePageNumbers,
  workspacePageRangeEnd,
  workspacePageRangeStart,
  workspaceSortBy,
  workspaceTotalPages
} from './workspace-widget-list-commons';

@Component({
  standalone: false,
  selector: 'adn-order-list-widget',
  template
})
export class OrderListWidgetComponent implements OnInit {
  @Input() widgetType: any;

  list: any = {};
  /** Snapshot — list-helper replaces list.items on settle (NG0100). */
  displayItems: any[] = [];
  hasItems = false;
  listPageSize = 25;
  listTotalCount = 0;
  listCurrentPage = 1;
  displayPage: any = {pageSize: 25, totalCount: 0, currentPage: 1};
  readonly columnHeaderFields: WorkspaceListColumn[] = [
    {param: '', label: 'blank'},
    {param: 'name', label: 'order'},
    {param: '', label: 'advertiser'}
  ];

  readonly isColumnSortable = isWorkspaceColumnSortable;
  readonly columnLabel = workspaceColumnLabel;
  readonly sortBy = workspaceSortBy;
  readonly changePage = workspaceChangePage;
  readonly totalPages = workspaceTotalPages;
  readonly pageNumbers = workspacePageNumbers;
  readonly pageRangeStart = workspacePageRangeStart;
  readonly pageRangeEnd = workspacePageRangeEnd;

  constructor(
    @Inject(OrderResource) private readonly Order: any,
    private readonly adnListHelper: AdnListHelperService,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.adnListHelper.setUpBasicList(this.list, this.Order, 'orderWidgetList', {
      listMethod: 'getListView',
      pageSize: Math.min((_.isFinite(this.widgetType.rows) && this.widgetType.rows > 0 ? this.widgetType.rows : 10), 100),
      afterFill: () => {
        deferMarkForCheck(this.cdr, () => {
          _.forEach(this.list.items, (item: any) => {
            item.lineItems = _.map(item.lineItems);
          });
          this.displayItems = (this.list.items || []).slice();
          this.hasItems = this.displayItems.length > 0;
          this.listPageSize = this.list.pageSize || 25;
          this.listTotalCount = this.list.totalCount || 0;
          this.listCurrentPage = this.list.currentPage || 1;
          this.displayPage = {
            pageSize: this.listPageSize,
            totalCount: this.listTotalCount,
            currentPage: this.listCurrentPage
          };
        });
      }
    });
  }

  toggleLineItems(item: any): void {
    item.expandLineItems = !item.expandLineItems;
  }
}
